import { ReactElement } from 'react';

export type getSuffixInputIconProps = {
  suffixIcon?: ReactElement | null;
  suffixEmptyIcon?: ReactElement | null;
  suffixFocusIcon?: ReactElement | null;
  isFocused: boolean;
  isEmpty: boolean;
};

export const getSuffixInputIcon = ({
  suffixIcon,
  suffixEmptyIcon,
  suffixFocusIcon,
  isFocused,
  isEmpty,
}: getSuffixInputIconProps): ReactElement | null => {
  if (!suffixIcon && !suffixEmptyIcon && !suffixFocusIcon) {
    return null;
  }
  if (suffixIcon && !suffixEmptyIcon && !suffixFocusIcon) {
    return suffixIcon;
  }
  if (isEmpty && isFocused) {
    return suffixFocusIcon ?? null;
  }
  const calculatedIcon = isEmpty ? suffixEmptyIcon : isFocused ? suffixFocusIcon : suffixIcon;
  return !calculatedIcon ? null : calculatedIcon;
};
